// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2GCsI","col":"styles_col__2-4Lx"};